import { ProjectModel } from "@app/catalog";

export class EditProjectMessage {
    public project: ProjectModel

    constructor(project: ProjectModel) {
        if (project !== undefined)
            {
                this.project = project;
            }
    }
}
